import { render, staticRenderFns } from "./art.vue?vue&type=template&id=74dfd66d"
import script from "./art.vue?vue&type=script&lang=js"
export * from "./art.vue?vue&type=script&lang=js"
import style0 from "./art.vue?vue&type=style&index=0&id=74dfd66d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports